








































import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import UploadQuestionForm, {
  UploadForm,
} from '@/components/modals/modal-upload-question/UploadQuestionForm.vue';
import UploadQuestionRadio, {
  UploadRadio,
} from '@/components/modals/modal-upload-question/UploadQuestionRadio.vue';
import UploadQuestionPublic from '@/components/modals/modal-upload-question/UploadQuestionPublic.vue';
import UploadQuestionFile, {
  UploadFile,
} from '@/components/modals/modal-upload-question/UploadQuestionFile.vue';
import Divider from '@/components/common/Divider.vue';
import { validateNotEmpty } from '@/utils/form-validation';
import QuestionUploadStore, {
  QuestionUploadStoreInterface,
} from '@/resource/question-upload/question-upload.store';
import { Collection } from '@/resource/collection/collection.model';
import ImageUploadStore, {
  ImageUploadInterface,
} from '@/resource/file-upload/file-upload.store';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

const defaultForms = [
  {
    id: 'subject',
    label: 'Subject',
    value: '',
    error: false,
  },
  {
    id: 'chapter',
    label: 'Chapter',
    value: '',
    error: false,
  },
  {
    id: 'form',
    label: 'Form',
    value: '',
    error: false,
  },
];

const defaultRadios = [
  {
    id: 'questionType',
    value: 'subjective',
  },
  {
    id: 'difficulty',
    value: 2,
  },
];

@Component({
  components: {
    Modal,
    Divider,
    UploadQuestionForm,
    UploadQuestionRadio,
    UploadQuestionFile,
    UploadQuestionPublic,
    BeatLoader,
  },
})
export default class ModalUploadQuestion extends Vue {
  @Prop()
  collection!: Collection;

  @Prop()
  showUploadQuestion!: boolean;

  @Prop()
  closeUploadQuestion!: () => void;

  uploadStore: QuestionUploadStoreInterface = QuestionUploadStore;
  imageUploadStore: ImageUploadInterface = ImageUploadStore;

  isLoading = false;

  file: UploadFile = {
    value: null,
    error: false,
  };

  isPublic = true;

  forms: UploadForm[] = JSON.parse(JSON.stringify(defaultForms));

  radios: UploadRadio[] = JSON.parse(JSON.stringify(defaultRadios));

  toggleIsPublic() {
    this.isPublic = !this.isPublic;
  }

  async submitQuestion() {
    if (this.isLoading) return;
    this.isLoading = true;
    let hasError = false;

    for (const form of this.forms) {
      if (!validateNotEmpty(form.value)) {
        form.error = `${form.label} cannot be empty`;
        hasError = true;
      } else {
        form.error = false;
      }
    }

    if (!this.file.value) {
      this.file.error = `Please upload question here`;
      hasError = true;
    }

    if (!hasError) {
      await this.upload();
    }

    this.isLoading = false;
  }

  async upload() {
    if (!this.imageUploadStore.response) {
      await this.imageUploadStore.imageUpload({ files: [this.file.value] });
    }

    if (this.imageUploadStore.error) {
      this.$toasted.global.mainToast({
        message: this.imageUploadStore.error.message,
      });
      return;
    }

    const params: any = {};

    params['fileUploadId'] = this.imageUploadStore.response?.id;
    params['collectionUUid'] = this.collection.uuid;
    params['isPrivate'] = !this.isPublic;

    this.forms.forEach(form => {
      params[form.id] = form.value;
    });

    this.radios.forEach(radio => {
      params[radio.id] = radio.value;
    });

    await this.uploadStore.createQuestionUpload(params);

    if (this.uploadStore.error) {
      this.$toasted.global.mainToast({
        message: this.uploadStore.error.message,
      });

      return;
    } else {
      this.closeModal();
      this.$toasted.global.mainToast({
        message: 'Request to add question successfully sent',
      });
    }
  }

  resetFields() {
    this.forms = JSON.parse(JSON.stringify(defaultForms));
    this.radios = JSON.parse(JSON.stringify(defaultRadios));
    this.isPublic = true;
    this.file.value = null;
    this.file.error = false;
  }

  closeModal() {
    this.closeUploadQuestion();
    this.imageUploadStore.setResponseToNull();
    this.resetFields();
  }
}
